package ui.theme

import org.jetbrains.compose.web.css.*

object AppColors {
    // Primary Brand Colors
    val primary = Color("#1976d2")
    val primaryVariant = Color("#1565c0")
    val primaryLight = Color("#42a5f5")
    val primaryDark = Color("#0d47a1")
    
    // Secondary Colors
    val secondary = Color("#64b5f6")
    val secondaryVariant = Color("#90caf9")
    val accent = Color("#7c4dff")
    
    // Surface Colors
    val background = Color("#f8fafc")
    val surface = Color("#ffffff")
    val surfaceVariant = Color("#f1f5f9")
    val surfaceTint = Color("#e2e8f0")
    
    // Text Colors
    val onPrimary = Color("#ffffff")
    val onSecondary = Color("#ffffff")
    val onBackground = Color("#0f172a")
    val onSurface = Color("#334155")
    val onSurfaceVariant = Color("#64748b")
    
    // Semantic Colors
    val error = Color("#dc2626")
    val onError = Color("#ffffff")
    val success = Color("#16a34a")
    val warning = Color("#ea580c")
    val info = Color("#0ea5e9")
    
    // Glassmorphism Colors (RGBA strings for CSS)
    val glassBackground = "rgba(255, 255, 255, 0.15)"
    val glassBackgroundHover = "rgba(255, 255, 255, 0.25)"
    val glassBorder = "rgba(255, 255, 255, 0.25)"
    val glassBorderHover = "rgba(255, 255, 255, 0.35)"
    val glassHighlight = "rgba(255, 255, 255, 0.4)"
    
    // Neomorphism Shadows (RGBA strings for CSS)
    val shadowLight = "rgba(255, 255, 255, 0.8)"
    val shadowDark = "rgba(0, 0, 0, 0.1)"
    val shadowPrimary = "rgba(25, 118, 210, 0.25)"
    val shadowPrimaryHover = "rgba(25, 118, 210, 0.35)"
    
    // Gradient Definitions
    val primaryGradient = "linear-gradient(135deg, #1976d2 0%, #42a5f5 50%, #64b5f6 100%)"
    val backgroundGradient = "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 50%, #cbd5e1 100%)"
    val cardGradient = "linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, transparent 50%, rgba(255, 255, 255, 0.05) 100%)"
    val ambientGradient = """
        radial-gradient(circle at 20% 20%, rgba(59, 130, 246, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 80% 80%, rgba(168, 85, 247, 0.08) 0%, transparent 50%),
        radial-gradient(circle at 40% 60%, rgba(16, 185, 129, 0.06) 0%, transparent 50%)
    """.trimIndent()
    
    // Interactive States
    val hoverTransform = "translateY(-8px) scale(1.02)"
    val activeTransform = "translateY(-4px) scale(1.01)"
    val pressedTransform = "translateY(-2px) scale(0.98)"
}

object DarkColors {
    // Dark Mode Colors
    val primary = Color("#64b5f6")
    val primaryVariant = Color("#42a5f5")
    val primaryLight = Color("#90caf9")
    val primaryDark = Color("#1976d2")
    
    val secondary = Color("#90caf9")
    val secondaryVariant = Color("#64b5f6")
    val accent = Color("#b39ddb")
    
    val background = Color("#0f172a")
    val surface = Color("#1e293b")
    val surfaceVariant = Color("#334155")
    val surfaceTint = Color("#475569")
    
    val onPrimary = Color("#0f172a")
    val onSecondary = Color("#0f172a")
    val onBackground = Color("#f1f5f9")
    val onSurface = Color("#e2e8f0")
    val onSurfaceVariant = Color("#94a3b8")
    
    val error = Color("#ef4444")
    val onError = Color("#ffffff")
    val success = Color("#22c55e")
    val warning = Color("#f97316")
    val info = Color("#38bdf8")
    
    // Dark Glassmorphism
    val glassBackground = "rgba(30, 41, 59, 0.4)"
    val glassBackgroundHover = "rgba(30, 41, 59, 0.6)"
    val glassBorder = "rgba(148, 163, 184, 0.25)"
    val glassBorderHover = "rgba(148, 163, 184, 0.4)"
    val glassHighlight = "rgba(255, 255, 255, 0.15)"
    
    // Dark Neomorphism
    val shadowLight = "rgba(71, 85, 105, 0.5)"
    val shadowDark = "rgba(0, 0, 0, 0.8)"
    val shadowPrimary = "rgba(100, 181, 246, 0.3)"
    val shadowPrimaryHover = "rgba(100, 181, 246, 0.45)"
    
    // Dark Gradients
    val primaryGradient = "linear-gradient(135deg, #64b5f6 0%, #42a5f5 50%, #1976d2 100%)"
    val backgroundGradient = "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)"
    val cardGradient = "linear-gradient(135deg, rgba(148, 163, 184, 0.15) 0%, transparent 50%, rgba(148, 163, 184, 0.08) 100%)"
    val ambientGradient = """
        radial-gradient(circle at 20% 20%, rgba(100, 181, 246, 0.2) 0%, transparent 50%),
        radial-gradient(circle at 80% 80%, rgba(179, 157, 219, 0.15) 0%, transparent 50%),
        radial-gradient(circle at 40% 60%, rgba(34, 197, 94, 0.1) 0%, transparent 50%)
    """.trimIndent()
}
